import { motion, Variants } from 'framer-motion'
import Link from 'next/link'
import React, { ReactNode, useRef, useState } from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from '../../../constants/breakpoints'

function random(min: number, max: number) {
  return Math.floor(Math.random() * max) + min
}

export interface StoryItemProps {
  xPos?: string
  yPos?: string
  height?: string
  width?: string
  children?: ReactNode
  className?: string
  style?: React.CSSProperties
  onMouseEnter?: (event: React.MouseEvent) => void
  onMouseLeave?: (event: React.MouseEvent) => void
  onClick?: () => void
  background?: string
  isOutboundLink?: boolean
  href?: string
  hoverTransform?: 'left-up' | 'right-up' | 'none'
  type?: 'Inbound' | 'Outbound' | 'Video'
}

const StoryItem: React.FC<StoryItemProps> = ({
  xPos,
  yPos,
  height,
  width,
  children,
  className,
  style,
  onMouseEnter,
  onMouseLeave,
  onClick,
  background,
  isOutboundLink,
  href,
  hoverTransform,
  type,
}) => {
  const variants = useRef<Variants>({
    crazy: {
      y: random(-50, 50),
      rotateX: random(-2, 2),
      rotateZ: random(-5, 5),
      z: [10, random(50, 1230 / 3)],
      transition: {
        duration: random(15, 20),
        ease: [0.3, 1, 0.3, 1],
      },
    },
  }).current

  const [crazy, setCrazy] = useState(false)
  // useEffect(() => {
  //   setTimeout(() => {
  //     setCrazy(true)
  //   }, 700)
  // }, [])

  const link = (
    <StyledLink
      variants={variants}
      animate={crazy ? 'crazy' : undefined}
      href={isOutboundLink ? `//${href}` : undefined}
      target={isOutboundLink ? '_blank' : '_self'}
      className={`${className} ${hoverTransform}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        height,
        width,
        top: yPos,
        left: xPos,
        background,
        ...style,
      }}
    >
      {children}
    </StyledLink>
  )

  if (isOutboundLink) {
    return link
  }

  const button = (
    <StyledButton
      className={`${className} ${hoverTransform}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        height,
        width,
        top: yPos,
        left: xPos,
        background,
        ...style,
      }}
    >
      {children}
    </StyledButton>
  )

  if (type === 'Video') {
    return button
  }

  return (
    <Link href={href || ''} passHref>
      {link}
    </Link>
  )
}

export default StoryItem

const StyledLink = styled(motion.a)`
  transition: transform 0.3s ease-in;
  /* transform-origin: 100% 50%; */
  transform: translate3d(0, 0, 10px);
  backface-visibility: hidden;

  pointer-events: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media ${mediaMin.mobileL} {
    &.right-up {
      transform-origin: 0% 50%;
    }
    &.left-up {
      transform-origin: 100% 50%;
    }
    &.left-up:hover {
      transform: rotate3d(0, 1, 0, 22deg) translate3d(0, 0, 10px) !important;
      transition: transform 0.3s ease-in;
    }
    &.right-up:hover {
      transform-origin: 0% 50%;
      transform: rotate3d(0, 1, 0, -22deg) translate3d(0, 0, 10px) !important;
      transition: transform 0.3s ease-in;
    }
  }
`

const StyledButton = styled.button`
  transition: transform 0.3s ease-in;
  /* transform-origin: 100% 50%; */
  transform: translate3d(0, 0, 10px);
  backface-visibility: hidden;

  pointer-events: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media ${mediaMax.mobileL} {
    padding: 0;
    border: none;
  }

  @media ${mediaMin.mobileL} {
    &.right-up {
      transform-origin: 0% 50%;
    }
    &.left-up {
      transform-origin: 100% 50%;
    }
    &.left-up:hover {
      transform: rotate3d(0, 1, 0, 22deg) translate3d(0, 0, 10px) !important;
      transition: transform 0.3s ease-in;
    }
    &.right-up:hover {
      transform-origin: 0% 50%;
      transform: rotate3d(0, 1, 0, -22deg) translate3d(0, 0, 10px) !important;
      transition: transform 0.3s ease-in;
    }
  }
`
